import React, { FunctionComponent } from 'react';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import ReusableTabs from '../common/ReusableTabs';
import investorRelationHeaderImage from '../../static/investor_image/investorHeader.png';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import ErrNoResultTemplate from './ErrNoResultTemplate';
import BreadCrumbs from '../common/BreadCrumbs';
import { toUrl } from '@/utils/convertImagePath';

interface Page404Props {}

const Page404: FunctionComponent<Page404Props> = (props) => {
    const { locale, messages } = useLocale();

    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <Box
                width="100%"
                component="main"
                sx={{
                    padding: 0,
                    flexGrow: 0,
                    p: 0, // 内边距
                }}
            >
                <ReusableTabs
                    bannerImage={toUrl(investorRelationHeaderImage)}
                    bannerTitle="Oh, ohm!"
                    bannerDescription="We couldn't find what you were looking for."
                    tabLabels={[]}
                    tabKeys={['']}
                    tabContents={[<ErrNoResultTemplate key="error-404" errorMsg={'404 Error'} />]}
                    bannerFontStyle={styles.bannerFont}
                    subBannerFontStyle={styles.bannerFont2}
                    pageName={'404'}
                    showTabs={false}
                    breadcrumbs={<BreadCrumbs navigationPath="/Home" />}
                />
            </Box>
        </IntlProvider>
    );
};

export default Page404;
